import * as React from 'react'
import { Column } from '../typings'
import { ReducerProps } from '../reducer'
import { selectionListItemStyles as useStyles } from './styles'

import FormControlLabel, {
  formControlLabelClasses,
} from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

interface Props extends ReducerProps {
  column: Column
}

export const SelectionListItem: React.FC<Props> = (props) => {
  const {
    column: { field, label, disabled, checked = false },
    dispatch,
  } = props

  const onChange = React.useCallback(
    (_e, value: boolean) =>
      dispatch({ type: 'toggle', payload: { field, value } }),
    [dispatch, field],
  )

  return (
    <FormControlLabel
      label={label}
      sx={{
        [`&.${formControlLabelClasses.root}`]: useStyles.root,
        [`.${formControlLabelClasses.label}`]: useStyles.label,
      }}
      control={
        <Checkbox
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          color="primary"
          size="small"
          disableRipple
          disableFocusRipple
          disableTouchRipple
        />
      }
    />
  )
}
